import React, {useState} from "react";

export const BlurredImage = ({ imageUrl }) => {
  const [loaded, setLoaded] = useState(false);

  return (
    <div style={{
      width: 200,
      height: 200,
      backgroundColor: loaded ? 'transparent' : '#e0e0e8',
      borderRadius: '10px',
      transition: 'background-color 0.3s',
    }}>
      <img
        src={imageUrl}
        alt="Descriptive alternative text"
        style={{
          width: '100%',
          height: '100%',
          display: 'block',
          opacity: loaded ? 1 : 0,
          transition: 'opacity 0.3s ease-in'
        }}
        onLoad={() => setLoaded(true)}
      />
    </div>
  );
};